export const API_URL = process.env.REACT_APP_API_URL;
export const GRAPH_API_URL = `${API_URL}/wp/graphql`;
export const WP_JSON_API_URL = `${API_URL}/wp-json`;
